/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  COURSE_COPY_REQUESTED,
  COURSE_COPY_FETCHED,
  COURSE_COPY_FAILED
} from '../../../common/constants';

export default class CopyCourseService extends BaseService {
  constructor() {
    super(COURSE_COPY_REQUESTED, 'courseCopyStatus');
  }

  handleEvent(eventName, { payload }) {
    return this.getClient('marin').post('/courseCopy', payload);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse({ data }) {
    Framework.getEventManager().publish(COURSE_COPY_FETCHED, data);
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error = {}) {
    const errorData = error?.response?.data;

    if (errorData) {
      Framework.getEventManager().publish(COURSE_COPY_FAILED, errorData);
    }
  }
}
